import { useEmailConfirmationModal } from "@js/apps/dashboard/hooks/use-email-confirmation-modal";
import { useSetWelcomeModalParam } from "@js/apps/employer/hooks/use-employer-welcome-modal";

import { AutoBlockUserWarningModalProvider } from "./components/auto-block-warning-modal";
import { CurrentOfferDepositProvider } from "./components/current-offer-deposit-provider";
import { EmployerPermissionChangeProvider } from "./components/employer-permission-change-provider";

const pathsToHideConfirmationModal = [
  /^\/onboarding\//,
  /\/auth\/logout/,
  /^\/verify_email/,
];

export const EmployerGlobalProvider = () => {
  const setSearchParam = useSetWelcomeModalParam();

  useEmailConfirmationModal({
    pathsToHideConfirmationModal,
    callback: setSearchParam,
  });

  return (
    <>
      <EmployerPermissionChangeProvider />
      <AutoBlockUserWarningModalProvider />
      <CurrentOfferDepositProvider />
    </>
  );
};
